import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { mockGroups } from './groups.mock';
import { IGroupDTOIn } from '../interfaces/groups/group.interface';
import { environment } from '../../environments/environment';

export const mockGroupsRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.GROUPS)) {
        const response: any = {
            status: 200,
            body: { groups: mockGroups },
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'GET' && request.url.includes(SubUrlsEnum.GROUP)) {
        const response: any = {
            status: 200,
            body: mockGroups.find((group: IGroupDTOIn) => group.id === +request.url.replace(environment.wasoApi + SubUrlsEnum.GROUP, '')),
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
